import type {Tax} from "./types";

import {type OptionType} from "@/client/components/Select";

export const taxTypes: OptionType<Tax["type"]>[] = [
    {
        value: "SalesTaxExcluded",
        label: "Sales Tax Excluded"
    },
    {
        value: "SalesTaxIncluded",
        label: "Sales Tax Included"
    }
];
